var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1328.272,
    height: 877.022,
    viewBox: "0 0 1328.272 877.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1fa085;opacity:0.1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M61.527,396.83H184.833V564.895H70.554c-.3,1.725-.6,3.463-.911,5.2h115.19v135.54c-.207-.061-.389-.134-.583-.206-3.256-1.288-6.488-2.649-9.72-4.107l-2.065-.936q-4.86-2.3-9.72-4.86c-1.13-.6-2.26-1.215-3.378-1.847a202.193,202.193,0,0,1-48.452-37.858c-.413-.4-.8-.826-1.215-1.215-1.968-2.138-3.9-4.3-5.771-6.512l-2.065-2.43c-2.211-2.709-4.35-5.492-6.427-8.31-.3-.413-.6-.826-.911-1.215a180.885,180.885,0,0,1-20.9-37.785c-.17-.4-.316-.838-.474-1.215q-2.5-6.439-4.435-13c-.559-1.835-1.093-3.645-1.555-5.552-.17-.559-.316-1.106-.45-1.652C59.814,550,59,522.019,59,494.233v-9.72c0-11.238.134-22.55.328-33.849,0-2.928.121-5.844.182-8.784q.255-11.19.729-22.379c.073-2.078.17-4.143.279-6.208a35.164,35.164,0,0,1,.182-3.572C60.993,405.4,61.236,401.107,61.527,396.83Z",
    transform: "translate(-59 14.075)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M174.536,257.934H106.9a512.727,512.727,0,0,1,35.975-49.522c10.047-12.344,20.654-24.372,31.662-35.962Z",
    transform: "translate(-48.704 -34.156)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M184.317,247.09V423.817H61.4c0-.51.085-1.033.121-1.543.109-1.4.219-2.794.34-4.179.134-1.628.279-3.268.437-4.86s.328-3.536.51-5.3.352-3.548.559-5.309.389-3.523.607-5.273.413-3.523.644-5.273c.182-1.458.377-2.9.571-4.362.279-2.053.571-4.119.887-6.16a5.68,5.68,0,0,1,.134-.911,420.252,420.252,0,0,1,9.051-44.37A328.137,328.137,0,0,1,90.51,291.327a337.458,337.458,0,0,1,22.938-44.176Z",
    transform: "translate(-58.484 -18.112)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M186.8,469.516V637.593H450.165V469.516Zm0,173.264V787.117c1.507.316,3,.62,4.483.875,2.017.389,4.021.741,6.075,1.045.389.061.79.121,1.215.158.8.134,1.628.243,2.43.352,2.029.279,4.046.51,6.075.693.96.1,1.932.182,2.9.255l2.345.182h0c1.276.1,2.539.17,3.791.206.778,0,1.555.073,2.357.1h8.663c1.045,0,2.09,0,3.122-.1h.073a16.372,16.372,0,0,0,2.175-.1,5.094,5.094,0,0,0,.607,0,12.564,12.564,0,0,0,1.8-.085h.425l4.07-.316c1.336-.121,2.685-.279,4.046-.425l2.77-.328a242.334,242.334,0,0,0,33.35-7.1c24.566-6.852,48.6-16.438,73.152-23.461,31.747-9.051,66.822-13.5,97.5-2.43V642.781ZM450.165,282.4V58.644A338.572,338.572,0,0,0,364.6,68.679c-66.689,16.754-126.525,53.093-177.8,99.5V282.389h13.219v5.188H186.8V464.329H450.165V287.589H254.291V282.4Zm338.279-75.582c-16.5-.583-32.9-5.807-47.735-13.875-28.369-15.43-51.028-39.255-76.348-59.363-52.607-41.879-117.85-67.15-184.782-73.42V282.4H855.547l.936-.984Zm34.25-6.075,36.315,39.85V190.3c-12.162,1.507-22.817,5.091-36.266,10.4Zm36.315,622.214V642.781h-77.38c-.206-.765-.413-1.543-.656-2.321.231.778.425,1.555.644,2.321H479.628v130.3c2.867,2.126,5.7,4.362,8.5,6.634h0c3.025,2.43,6.014,4.993,9.015,7.508l3.025,2.5c1.446,1.215,2.9,2.43,4.374,3.572q4.374,3.548,8.833,7c1.47,1.215,2.977,2.308,4.471,3.451a608.949,608.949,0,0,0,74.878,48.975q8.784,4.86,17.726,9.489c3.973,2.029,7.97,4.046,11.979,6q9.039,4.41,18.224,8.5h0a669.249,669.249,0,0,0,177.383,51.672q20.4,3.013,40.956,4.738V822.946h1.215ZM479.628,287.589V464.329h379.43V287.589Zm0,181.927V637.593h379.43V469.516Zm408.88-279.439v56.107l46.35-50.858q-23.036-3.718-46.35-5.309Zm0,279.5V637.593H1257.55V469.516ZM1256.2,836.3l1.3-193.518H888.508V935.062a661.8,661.8,0,0,0,71.318-.85h.413q17.009-1.069,33.861-3.11h.255a623.565,623.565,0,0,0,173.982-46.423M1328.71,497.193c-1.385-3.268-2.831-6.512-4.3-9.72-2.746-6.075-5.65-11.979-8.638-17.884h-28.794v168h72.8c-.037-47.578-12.077-96.176-31.03-140.461Zm-41.734,145.648V809.29c20.508-19.658,37.834-42.147,50.311-67.855,15-30.957,21.869-64.478,22.428-98.618Zm0-222.239v43.738h26.1a473.86,473.86,0,0,0-26.061-43.8ZM1036.7,223.051c-1.92-.729-3.839-1.47-5.771-2.187a526.823,526.823,0,0,0-62.339-18.735l-70.929,77.842h0l-1.361,1.446.911,1H1149.65a539.936,539.936,0,0,0-112.918-59.423Zm120.353,64.6H893.684l-5.176,4.738v171.94H1257.6V381.043a525.829,525.829,0,0,0-100.513-93.454Z",
    transform: "translate(-31.529 -58.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M184.317,320.46v87.586H61.4c0-.51.085-1.033.121-1.543.109-1.4.219-2.794.34-4.179.134-1.628.279-3.268.437-4.86s.328-3.536.51-5.3.352-3.548.559-5.309.389-3.523.607-5.273.413-3.523.644-5.273c.182-1.458.377-2.9.571-4.362.279-2.053.571-4.119.887-6.16a5.68,5.68,0,0,1,.134-.911,420.252,420.252,0,0,1,9.051-44.37Z",
    transform: "translate(-58.484 -2.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M61.527,396.83H184.833V564.895H70.554c-.3,1.725-.6,3.463-.911,5.2h115.19v135.54c-.207-.061-.389-.134-.583-.206-3.256-1.288-6.488-2.649-9.72-4.107l-2.065-.936q-4.86-2.3-9.72-4.86c-1.13-.6-2.26-1.215-3.378-1.847a202.193,202.193,0,0,1-48.452-37.858c-.413-.4-.8-.826-1.215-1.215-1.968-2.138-3.9-4.3-5.771-6.512l-2.065-2.43c-2.211-2.709-4.35-5.492-6.427-8.31-.3-.413-.6-.826-.911-1.215a180.885,180.885,0,0,1-20.9-37.785c-.17-.4-.316-.838-.474-1.215q-2.5-6.439-4.435-13c-.559-1.835-1.093-3.645-1.555-5.552-.17-.559-.316-1.106-.45-1.652C59.814,550,59,522.019,59,494.233v-9.72c0-11.238.134-22.55.328-33.849,0-2.928.121-5.844.182-8.784q.255-11.19.729-22.379c.073-2.078.17-4.143.279-6.208a35.164,35.164,0,0,1,.182-3.572C60.993,405.4,61.236,401.107,61.527,396.83Z",
    transform: "translate(-59 14.075)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M232.273,218.351V369.783H139.56V218.351h13.219V167.08h54.26v51.271Z",
    transform: "translate(15.711 35.922)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 92.701,
    height: 168.064,
    transform: "translate(155.283 410.892)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M186.8,539.44h92.713V679.16a241.92,241.92,0,0,1-33.35,7.083l-2.77.34c-1.361.158-2.709.292-4.046.425s-2.721.231-4.07.316h-.425c-.583,0-1.215.073-1.786.085h-.62c-.729,0-1.458.073-2.187.1h0c-1.033.061-2.065.073-3.122.085h-8.6l-2.345-.085c-1.215,0-2.527-.134-3.791-.219h0l-2.333-.17-2.9-.267c-2.041-.182-4.07-.413-6.075-.693l-2.43-.34-1.215-.17c-2.029-.316-4.034-.656-6.075-1.045-1.494-.255-2.977-.571-4.483-.875Z",
    transform: "translate(-31.529 44.729)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 76.445,
    height: 169.304,
    transform: "translate(751.084 236.389)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M760.022,338.19V506.267H380.58v-72.5H582.687v42.766H683.565V338.19Z",
    transform: "translate(67.52 72.703)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M808.465,720.052H807.25V830.309q-20.533-1.737-40.944-4.726A669.278,669.278,0,0,1,588.85,773.8q-24.457-11.007-47.918-24.032a611.452,611.452,0,0,1-74.89-48.975q-8.942-6.852-17.653-14.02c-4.021-3.317-8.019-6.719-12.064-10.023-2.807-2.272-5.637-4.508-8.5-6.646V539.851H729.8c-.207-.778-.413-1.555-.632-2.32.231.765.449,1.543.656,2.32H807.25V719.98C807.663,719.992,808.064,720.028,808.465,720.052Z",
    transform: "translate(20.279 44.318)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M913.033,253.706H863.22V238.228h22.331V192.12q2.9,1.057,5.783,2.175v43.933h21.7Z",
    transform: "translate(113.869 -29.928)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1054.3,423.817H809.751l.085.061-.109-.061H764.36v-169.3h12.854v125.14h58.743V305.541h48.525V247.09H934.3v58.5h48.525V379.7H1054.3Z",
    transform: "translate(92.619 -18.112)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M764.36,396.82V564.9H1054.3V396.82ZM1133,762.74l.4-133.037H1054.3V570.17H764.36v292.2a661.822,661.822,0,0,0,71.318-.85h.413q17.009-1.069,33.861-3.11h.255a623.564,623.564,0,0,0,173.981-46.423",
    transform: "translate(92.619 14.073)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1097.473,539.44h67.636c-.6,34.128-7.448,67.649-22.44,98.606-12.478,25.721-29.815,48.209-50.3,67.855V598.985h5.1Z",
    transform: "translate(163.126 44.729)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1164.243,560.011H1096.57V419.55h36.619C1152.142,463.835,1164.182,512.433,1164.243,560.011Z",
    transform: "translate(164.029 18.958)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40.956,
    height: 53.081,
    transform: "translate(786.585 283.456)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40.956,
    height: 12.222,
    transform: "translate(786.585 393.482)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40.956,
    height: 35.659,
    transform: "translate(786.585 410.892)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40.956,
    height: 53.081,
    transform: "translate(786.585 503.508)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40.956,
    height: 53.081,
    transform: "translate(786.585 613.535)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M747.364,694.907a6.734,6.734,0,0,1,1.215.073h-1.215v12.332H706.42V654.17h40.944Z",
    transform: "translate(80.165 69.391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M747.364,744.71v41q-20.533-1.737-40.944-4.726V744.71Z",
    transform: "translate(80.165 88.852)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 175.524,
    height: 3.9,
    transform: "translate(448.099 575.069)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 175.524,
    height: 14.944,
    transform: "translate(448.099 584.157)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 175.524,
    height: 24.032,
    transform: "translate(448.099 648.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M601.83,652.15v24.032H464.54q-8.942-6.828-17.665-14.021c-4.021-3.317-8.007-6.719-12.064-10.011Z",
    transform: "translate(21.781 68.956)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M583.32,712.246v24.008H568.826q-24.433-11.02-47.906-24.044Z",
    transform: "translate(40.291 81.867)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 34.553,
    height: 34.553,
    transform: "translate(928.31 427.185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 34.553,
    height: 34.553,
    transform: "translate(180.165 266.192)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 34.553,
    height: 34.553,
    transform: "translate(180.165 346.452)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 34.553,
    height: 34.553,
    transform: "translate(180.165 426.711)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 34.553,
    height: 34.553,
    transform: "translate(180.165 506.959)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 34.553,
    height: 34.553,
    transform: "translate(180.165 587.219)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 34.553,
    height: 34.553,
    transform: "translate(180.165 667.478)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 34.553,
    height: 34.553,
    transform: "translate(928.31 512.414)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 34.553,
    height: 34.553,
    transform: "translate(928.31 597.631)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 34.553,
    height: 34.553,
    transform: "translate(928.31 682.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 34.553,
    height: 34.553,
    transform: "translate(928.31 768.089)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 34.553,
    height: 34.553,
    transform: "translate(1060.217 768.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M775.83,724.612V702.33h34.541v19.111Z",
    transform: "translate(152.479 150.975)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M65.24,357v19.767H183.491V357Zm11.785,18.528H67.378V358.215H77.1Zm11.773,0h-9.72V358.215H88.8Zm11.749,0h-9.72V358.215h9.72Zm11.773,0h-9.707V358.215h9.72Zm11.761,0h-9.72V358.215h9.72Zm11.773,0h-9.72V358.215h9.72Zm11.773,0h-9.72V358.215h9.72Zm11.761,0h-9.72V358.215h9.72Zm11.761,0h-9.72V358.215h9.72Zm11.761,0h-9.72V358.215h9.72Z",
    transform: "translate(-57.658 5.513)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M65.24,404.34v19.767H183.491V404.34Zm11.785,18.516H67.378V405.591H77.1Zm11.773,0h-9.72V405.591H88.8Zm11.749,0h-9.72V405.591h9.72Zm11.773,0h-9.707V405.591h9.72Zm11.761,0h-9.72V405.591h9.72Zm11.773,0h-9.72V405.591h9.72Zm11.773,0h-9.72V405.591h9.72Zm11.761,0h-9.72V405.591h9.72Zm11.761,0h-9.72V405.591h9.72Zm11.761,0h-9.72V405.591h9.72Z",
    transform: "translate(-57.658 15.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M65.24,451.7v19.8H183.491V451.7Zm11.785,18.516H67.378V452.939H77.1Zm11.773,0h-9.72V452.939H88.8Zm11.749,0h-9.72V452.939h9.72Zm11.773,0h-9.707V452.939h9.72Zm11.761,0h-9.72V452.939h9.72Zm11.773,0h-9.72V452.939h9.72Zm11.773,0h-9.72V452.939h9.72Zm11.761,0h-9.72V452.939h9.72Zm11.761,0h-9.72V452.939h9.72Zm11.761,0h-9.72V452.939h9.72Z",
    transform: "translate(-57.658 25.869)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M65.24,499.06V518.8H183.491V499.06Zm11.785,18.516H67.378V500.287H77.1Zm11.773,0h-9.72V500.287H88.8Zm11.749,0h-9.72V500.287h9.72Zm11.773,0h-9.707V500.287h9.72Zm11.761,0h-9.72V500.287h9.72Zm11.773,0h-9.72V500.287h9.72Zm11.773,0h-9.72V500.287h9.72Zm11.761,0h-9.72V500.287h9.72Zm11.761,0h-9.72V500.287h9.72Zm11.761,0h-9.72V500.287h9.72Z",
    transform: "translate(-57.658 36.049)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M65.66,546.41c.474,1.859,1.008,3.718,1.567,5.552v-4.313h9.72v17.277h-5.2c.158.4.316.838.474,1.215H183.4V546.41Zm23.084,18.516h-9.72V547.649h9.72Zm11.749,0h-9.72V547.649h9.72Zm11.773,0h-9.744V547.649h9.72Zm11.761,0h-9.72V547.649h9.72Zm11.773,0h-9.72V547.649h9.72Zm11.773,0h-9.72V547.649h9.72Zm11.761,0h-9.72V547.649h9.72Zm11.761,0h-9.72V547.649h9.72Zm11.761,0h-9.72V547.649h9.72Z",
    transform: "translate(-57.568 46.227)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M88.26,593.77c.3.389.6.826.911,1.215H95.6v8.3c.693.826,1.373,1.652,2.078,2.43V594.936h9.72v17.337h-3.936c.389.4.765.826,1.215,1.215H178.58V593.77Zm30.872,18.5h-9.72V595.009h9.72Zm11.773,0h-9.72V595.009h9.72Zm11.773,0h-9.72V595.009h9.72Zm11.761,0h-9.72V595.009h9.72Zm11.761,0h-9.72V595.009h9.72Zm11.761,0h-9.72V595.009h9.72Z",
    transform: "translate(-52.71 56.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M141.65,641.12c1.106.632,2.236,1.215,3.378,1.847v-.608h9.72v5.467l2.065.96v-6.427h9.72v10.509a3.041,3.041,0,0,0,.583.219V641.12Z",
    transform: "translate(-41.234 66.586)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M931.552,424.744ZM856.711,783.325Zm-78.085-182.45c.231.778.425,1.555.644,2.321h0C779.075,602.43,778.869,601.653,778.626,600.875ZM931.552,424.707ZM197.72,242.78v5.188h54.272V242.78ZM856.711,783.325Zm-78.085-182.45c.231.778.425,1.555.644,2.321h0C779.075,602.43,778.869,601.653,778.626,600.875ZM931.552,424.707ZM856.711,783.288ZM778.626,600.875c.231.778.425,1.555.644,2.321h0C779.075,602.43,778.869,601.653,778.626,600.875Z",
    transform: "translate(-29.182 -19.039)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.c80523fdf6018a8c454a8d3a7f6d84ec.svg";
export { ForwardRef as ReactComponent };